import { render, staticRenderFns } from "./EmailStats.vue?vue&type=template&id=12f0a1ca&"
import script from "./EmailStats.vue?vue&type=script&lang=js&"
export * from "./EmailStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f0a1ca')) {
      api.createRecord('12f0a1ca', component.options)
    } else {
      api.reload('12f0a1ca', component.options)
    }
    module.hot.accept("./EmailStats.vue?vue&type=template&id=12f0a1ca&", function () {
      api.rerender('12f0a1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/EmailStats.vue"
export default component.exports